module.exports = __webpack_public_path__ + "img/banner.87d0aa94.jpg";